export default __webpack_public_path__ + "static/media/calendar.24ecf459.svg";